import script from "./table-config.vue?vue&type=script&setup=true&lang=js"
export * from "./table-config.vue?vue&type=script&setup=true&lang=js"

import "./table-config.vue?vue&type=style&index=0&id=53443840&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53443840"]])

export default __exports__